<template>
	<v-row no-gutters>
		<v-col cols="12" class="d-flex justify-center">
			<v-text-field
				name="message"
				placeholder="Escribe tu mensaje aquí!"
				id="id"
				v-model="message"
				class="input-container-flex"
				dense
				rounded
				flat
				height="46"
				background-color="#fff"
				hide-details="auto"
				@keydown.enter="sendMessage"
				color="var(--secondary-color)"
				ref="chatInput"
			>
				<!-- prepend-inner-icon="mdi-cart"
				@click:prepend-inner="showCart" -->
				<template v-slot:prepend-inner>
					<div class="icon-container" @click="showCart">
						<v-icon size="30" color="#22214A">
							mdi-cart-variant
						</v-icon>
						<span v-if="cart" class="cart-counter">{{
							cartCounter
						}}</span>
					</div>
				</template>
				<template v-slot:append-outer>
					<div @click="handleOuterIconClick">
						<v-icon size="30" color="var(--secondary-color)">
							{{ message ? "mdi-send" : "mdi-paperclip" }}
						</v-icon>
					</div>
				</template>
			</v-text-field>
			<input
				type="file"
				accept="image/*"
				name="load_file"
				id="load_file"
				class="hidden_load_file"
				@change="handleFiles"
				ref="files"
			/>
		</v-col>
	</v-row>
</template>
<script>
export default {
	data: () => ({
		message: "",
	}),
	computed: {
		cart() {
			return this.$store.getters["chatStore/get_cart"];
		},
		cartCounter() {
			let counter = 0;
			if(this.cart.products) counter += this.cart.products.length;
			if(this.cart.extras) counter += this.cart.extras.length;
			return counter;
		}
	},
	methods: {
		handleOuterIconClick() {
			if (this.message) {
				this.sendMessage();
			} else {
				this.loadFile();
			}
		},
		sendMessage() {
			if (!this.message) {
				return;
			}
			const status = this.$store.getters["chatStore/get_status"];
			if (status == "payment") {
				let fd = new FormData();
				fd.append("message", this.message);
				fd.append("driver", "web");
				fd.append("store_id", this.$route.params.id);
				const data = {
					id: this.$route.params.id,
					data: fd,
					raw: this.message,
				};
				this.$store.dispatch("chatStore/user_send_message", data);
			}
			if (status == "check-email") {
				let fd = new FormData();
				fd.append("email", this.message.trim());
				fd.append("store_id", this.$route.params.id);
				this.$store.dispatch("chatStore/checkEmail", {
					fd: fd,
					message: this.message.trim(),
					store: this.$route.params.id,
				});
			}
			if (status == "get-address") {
				this.$store.dispatch("chatStore/get_address", this.message);
			}
			this.message = "";
			// this.$store.commit('chatStore/ADD_MESSAGE', this.message)
		},
		loadFile() {
			let element = document.getElementById("load_file");
			element.click();
		},
		handleFiles(e) {
			if (e.target.files[0]) {
				this.$store.dispatch("chatStore/user_send_file", {
					file: e.target.files[0],
					id: this.$route.params.id,
				});
			}
		},
		showCart() {
			this.$store.dispatch("chatStore/setStatusToShowCart");
		},
	},
};
</script>
<style lang="scss">
.chat-input div.row.no-gutters {
	margin-left: 30px;
}
.input-container-flex {
	display: flex !important;
	align-items: center !important;
	position: relative !important;
}
.v-input__apend-outer {
	display: flex !important;
	align-items: center !important;
	margin: 5px auto !important;
}
.hidden_load_file {
	display: none;
}
.icon-container {
	position: relative;
	top: 10px;
	right: 10px;
	i {
		height: 30px;
		width: 30px;
	}
	.cart-counter {
		position: absolute;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 12px;
		width: 18px;
		height: 18px;
		top: -7px;
		right: -11px;
		border-radius: 50%;
		background-color: red;
		color: white;
	}
}
.v-input__slot {
	border: 1px solid var(--secondary-color) !important;
}
// .v-input__control,
// .v-input__control * {
// 	min-height: 30px !important;
// 	height: 30px;
// }
</style>
